/*------------------------------------*\
	#HEADER
\*------------------------------------*/

function initHeaderFlyout() {

	const triggerHeaderFlyoutMobile = document.querySelector('.js-trigger-header-flyout-mobile'),
		headerFlyoutMobile = document.querySelector('.js-site-nav'),
		breakpointTablet = 1024;

	let viewportWidth = window.innerWidth,
		windowHeight = window.innerHeight,
		headerHeight = document.querySelector('.js-header').offsetHeight;

	window.addEventListener('resize', () => {
		viewportWidth = window.innerWidth;
		windowHeight = window.innerHeight;
		headerHeight = document.querySelector('.js-header').offsetHeight;

		if (viewportWidth > breakpointTablet) {

			const headerFlyoutMobileIsOpen = headerFlyoutMobile.classList.contains('is-open');

			headerFlyoutMobile.style.height = '';

			if (headerFlyoutMobileIsOpen) {
				_toggleMobileFlyout(headerFlyoutMobile, triggerHeaderFlyoutMobile);
				_closeAllHeaderFlyouts();

			}

		}

		if (viewportWidth < breakpointTablet) {

			// set flyout height (100vh - header height)
			headerFlyoutMobile.style.height = windowHeight - headerHeight + 'px';

			if (triggerHeaderFlyoutMobile.classList.contains('is-open')) {
				_toggleMobileFlyout(headerFlyoutMobile, triggerHeaderFlyoutMobile);
			}

		}

	});

	_closeCurrentHeaderFlyout();
	_triggerHeaderFlyout();

	if (viewportWidth < breakpointTablet && triggerHeaderFlyoutMobile) {

		// set flyout height (100vh - header height)
		headerFlyoutMobile.style.height = windowHeight - headerHeight + 'px';
	}

	triggerHeaderFlyoutMobile.addEventListener('click', () => {
		_toggleMobileFlyout(headerFlyoutMobile, triggerHeaderFlyoutMobile);
	});

}

function _triggerHeaderFlyout() {

	const triggerHeaderFlyout = document.querySelectorAll('.js-trigger-header-flyout');

	triggerHeaderFlyout.forEach(function (trigger) {

		const navigationListItem = trigger.closest('[data-site-nav-item]'),
			headerFlyout = navigationListItem.querySelector('[data-site-nav-flyout]');

		headerFlyout.inert = true;
		headerFlyout.querySelector('[data-site-nav-level]').inert = true;

		// toggle header Flyout
		trigger.addEventListener('click', () => {

			const navigationListItem = trigger.closest('[data-site-nav-item]'),
				headerFlyout = navigationListItem.querySelector('[data-site-nav-flyout]'),
				headerFlyoutIsOpen = headerFlyout.classList.contains('is-visible');

			if (headerFlyoutIsOpen) {
				_closeFlyout(navigationListItem, headerFlyout);
				trigger.setAttribute('aria-expanded', 'false');
			} else {
				_closeAllHeaderFlyouts();
				_openHeaderFlyout(trigger, headerFlyout);
			}

		});

	});
}

function _openHeaderFlyout(trigger, headerFlyout) {

	const navigationListItem = trigger.closest('[data-site-nav-item]'),
		navigationList = headerFlyout.querySelector('[data-site-nav-level]');

	navigationListItem.setAttribute('data-show-sublist', 'true');
	headerFlyout.classList.add('is-visible');
	headerFlyout.inert = false;
	navigationList.inert = false;
	trigger.setAttribute('aria-expanded', 'true');
}

function _toggleMobileFlyout(headerFlyoutMobile, triggerHeaderFlyoutMobile) {

	const headerFlyoutMobileIsOpen = headerFlyoutMobile.classList.contains('is-open');

	if (headerFlyoutMobileIsOpen) {
		document.querySelector('html').classList.remove('is-not-scrollable');
		triggerHeaderFlyoutMobile.classList.remove('is-open');
		headerFlyoutMobile.classList.remove('is-open');
		triggerHeaderFlyoutMobile.setAttribute('aria-expanded', 'false');
	} else {
		document.querySelector('html').classList.add('is-not-scrollable');
		triggerHeaderFlyoutMobile.classList.add('is-open');
		headerFlyoutMobile.classList.add('is-open');
		triggerHeaderFlyoutMobile.setAttribute('aria-expanded', 'true');
	}

}

function _closeCurrentHeaderFlyout() {
	const closeHeaderFlyout = document.querySelectorAll('.js-close-header-flyout');

	closeHeaderFlyout.forEach(function (closeButton) {

		const navigationListItem = closeButton.closest('[data-site-nav-item]'),
			headerFlyout = navigationListItem.querySelector('[data-site-nav-flyout]');

		closeButton.addEventListener('click', () => {
			_closeFlyout(navigationListItem, headerFlyout);
			closeButton.closest('[data-site-nav-item]').querySelector('.js-trigger-header-flyout').setAttribute('aria-expanded', 'true');
		});

	});

}

function _closeAllHeaderFlyouts() {

	const headerFlyouts = document.querySelectorAll('[data-site-nav-flyout]');

	headerFlyouts.forEach(headerFlyout => {
		headerFlyout.closest('[data-site-nav-item]').setAttribute('data-show-sublist', 'false');
		headerFlyout.closest('[data-site-nav-item]').querySelector('.js-trigger-header-flyout').setAttribute('aria-expanded', 'false');
		headerFlyout.classList.remove('is-visible');
		headerFlyout.inert = true;
		headerFlyout.querySelector('[data-site-nav-level]').inert = true;
	});

}

function _closeFlyout(navigationListItem, headerFlyout) {
	navigationListItem.setAttribute('data-show-sublist', 'false');
	headerFlyout.classList.remove('is-visible');
	headerFlyout.inert = true;
	headerFlyout.querySelector('[data-site-nav-level]').inert = true;
}

function getHeaderHeight()  {
	const header = document.querySelector('.js-header');

	if (header) {
		document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
	}
}

document.addEventListener("DOMContentLoaded", () => {
	initHeaderFlyout();
	getHeaderHeight();
});

window.addEventListener("resize", () => {
	getHeaderHeight();
});
